module.exports = __webpack_public_path__ + "static/img/back3.7865ca2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back3.webp
// module id = akZB
// module chunks = 1